import { Trans } from "react-i18next";
import {arrayRotate} from "./utils"
import { Link } from "react-router-dom";

function strToMins(t) {
    var s = t.split(":");
    return Number(s[0]) * 60 + Number(s[1]);
}

function minsToStr(t) {
    return Math.trunc(t / 60) + ':' + ('00' + t % 60).slice(-2);
}
 

const Box = ({ employee, index, day, public_holidays, subk, toggle, addShiftData, match}) => {
    if (public_holidays){

        // Check first if on the day provided there are no public holidays if yes then mark the day as a public holiday
        for (const ph of public_holidays || []) {
            if (new Date(ph.date).setHours(0, 0, 0, 0) == day.setHours(0, 0, 0, 0)) {
                return (
                    <td className="border-0 box bx-orange" key={subk}>
                        <div>
                            <i className="far fa-flag" aria-hidden="true"></i>
                            <span className="d-block m-2"><Trans>Holiday</Trans></span>
                        </div>
                    </td>
                )
            } 
        }
    }

    // Check if the day provided is on the period of employment of the employee

    if (employee.start_date && new Date(employee.start_date) > day){
        return (
            <td className="border-0 box bx-gray" key={subk}>
                <div>
                    <i className="far fa-calendar-times" aria-hidden="true"></i>
                    <span className="d-block m-2"> <Trans>Not Started</Trans> </span>
                </div>
            </td>
        )
    }else if(employee.end_date && new Date(employee.end_date) < day){
        return (
            <td className="border-0 box bx-gray" key={subk}>
                <div>
                    <i className="far fa-calendar-times" aria-hidden="true"></i>
                    <span className="d-block m-2"> <Trans>End of Service</Trans> </span>
                </div>
            </td>
        )
    }

    else if (employee.working_days && arrayRotate([...employee.working_days], 1)[index]) {
        // Check if he has an approved holiday then mark them
        for (const hd of employee.approved_holidays) {
            if (new Date(hd.starting) <= day && (new Date(hd.ending) >= day)) {
                return (
                    <td className="border-0 box bx-yellow" key={subk}>
                        <div>
                            <i className="fa fa-plane" aria-hidden="true"></i>
                            <span className="d-block m-2"> <Trans>On Leave</Trans> </span>
                        </div>
                    </td>
                )
            }
        }

        if (!employee.shift_adj || (!employee.shift_adj.permanent && (new Date(employee.shift_adj.date_from)> day || new Date(employee.shift_adj.date_to) < day)) ) {
            //If the employee doesn't have a shift attached to it
            //Of the day provided doesn't belong to the employee's shift if not then mark the days as free so a shift will be 
            return (
                <td 
                onClick={() => {
                        addShiftData.current.userId=employee.id;
                        addShiftData.current.date_from=day;
                        addShiftData.current.date_to=day
                        toggle()
                    }} className="border-0 add-shift">

                    <i style={{ color: "#72B566", fontSize: "19px" }} className="fa fa-plus-circle" aria-hidden="true" ></i>
                    <span className="d-block m-2"><Trans>Add Shift</Trans></span>
                        
                </td>
            )
        }
        // else {
        //     console.log("Employee Shift :", employee.shift_adj)
        //     console.log("Employee Shift match:", match)
        //     console.log("Index :", index)
        //     console.log("subk :", subk)
        //     console.log("day :", day)
        //     console.log("addShiftData :", addShiftData)
        //     console.log("toggle :", toggle)
        //     console.log("Public Holidays :", public_holidays)
            
        //     return (
        //         <td>
        //             <Link
        //             className="btn btn-primary btn-sm mr-2 fix-bg-edit-btn"
        //             style={{ borderRadius: "6px", backgroundColor: "rgb(114, 181, 102)", borderColor: "rgb(114, 181, 102)", padding: "7.2px 10.5px" }}
        //             to={`/payroll-new/shift/${employee.shift_adj.id}`}
        //         >
        //             {/* <Button color="success" className='mr-2'> */}
        //             <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: '14px' }}></i>
        //             {/* </Button> */}
        //         </Link>
        //         </td>
        //     )
        // }
        //If he has a shift and no public or approved holidays then mark that day as a working day
        return (
            <td className="border-0 box bx-blue" key={subk}>
                {employee.shift_adj.time_from.substring(0, 5)}- {employee.shift_adj.time_to.substring(0, 5)}
                <span className="d-block m-2">
                    {minsToStr(Math.abs(strToMins(employee.shift_adj.time_to.substring(0, 5)) - strToMins(employee.shift_adj.time_from.substring(0, 5))))} <Trans>hrs</Trans>
                </span>
            </td>
        )
    } else {
        //If the employee is not working that day then it means it's a day off
        return (
            <td className="border-0 box bx-white" key={subk} >
                <Trans>Week off</Trans>
            </td>
        )
    }
}

export default Box